import type CustomWindow from 'interfaces/Utils';
import { Microsites } from 'constants/constants';
import { type RefObject, useEffect } from 'react';

declare let window: CustomWindow;

export interface Props {
  url: string;
  ownAudio?: string;
  noTrinityAds: boolean;
  paywallCheck?: string;
  trinityRef: RefObject<HTMLElement>;
  microsite: string;
}

const TrinityPlayer = ({ url, ownAudio, noTrinityAds, paywallCheck, trinityRef, microsite }: Props) => {
  useEffect(() => {
    if (window.__TRINITY_SCRIPT_LOADED__) {
      return;
    }
    const script = document.createElement('script');

    if (paywallCheck !== 'pending') {
      const playerType = paywallCheck === 'no-paywall' ? '' : 'subscription-locked';
      const adStatus = noTrinityAds ? 1 : 0;
      let id;

      switch (microsite) {
        case Microsites.Asia:
          id = 2900019104;
          break;
        case Microsites.Europe:
          id = 2900019105;
          break;
        case Microsites.Well:
          id = 2900019106;
          break;
        case Microsites.Crypto:
          id = 2900019107;
          break;
        default:
          id = 2900017491;
          break;
      }

      script.src = `https://trinitymedia.ai/player/trinity/${id}/?pageURL=${encodeURIComponent(
        url,
      )}&FAB=fabAfterClick&subscriber=${adStatus}&playerType=${playerType}`;
      if (ownAudio) {
        script.src += `&cf=${encodeURIComponent(ownAudio || '')}`;
      }
      script.async = true;
      script.type = 'text/javascript';

      if (trinityRef.current) {
        if (window.TRINITY_PLAYER?.api) {
          window.TRINITY_PLAYER.api.deletePlayer();
        }
        window.__TRINITY_SCRIPT_LOADED__ = true;
        trinityRef.current.appendChild(script);
      }
    }
  }, [url, trinityRef, noTrinityAds, paywallCheck, microsite]);

  return (
    <div
      className='trinity-tts-pb'
      dir='ltr'
    />
  );
};

export default TrinityPlayer;
